import React, { useState, useMemo, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import "./modal.scss";
import { EditableRowPPB } from "./EditableRowPPB";

export default function PillerAndPowerBrandModal({
  openModel,
  wholeRowData,
  handleSave,
  sourceData,
  updateSourceInputs,
  setIsEditDialogOpen,
  updateAlert,
  customStyles,
  editingIndex,
  handleDeleteRow,
  selectClasses,
  inputClasses,
  allRowsData,
  tableName,
  setIsDeleteDialogOpen,
  setCurrentDeletingRowData,
  ...props
}) {
  const [errorMessage, setErrorMessage] = useState();
  const [rowHasError, setRowHasError] = useState(false);
  const [rowData, setRowData] = useState(wholeRowData.rowData);
  const [updatedData, setUpdatedRowData] = useState();
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [dropdownData, setDropDownData] = useState(
    sourceData?.data?.dropdown || {},
  );
  const [rbBrandValues, setRbBrandValues] = useState("");
  const Edit_Column_Module =
    sourceData?.data?.dropdown?.edit_model_column_list || [];

  const Is_New_Data_Not_Null = useMemo(() => {
    return sourceData?.data?.dropdown?.duplicate_validation_attributes
      ? sourceData.data.dropdown.duplicate_validation_attributes.every(
          (item) => {
            return (
              wholeRowData?.rowData?.[item] &&
              wholeRowData?.rowData?.[item] !== null
            );
          },
        )
      : false;
  }, [wholeRowData?.rowData, rowData]);

  const isCurrentRecordExistINNewPowerBrandLogs = useMemo(() => {
    return (
      sourceData?.isNewPowerBrand_logs?.some((item) =>
        sourceData?.data.dropdown.duplicate_validation_attributes_for_other_flow?.every?.(
          (key) => item?.[key] === wholeRowData?.rowData?.[key],
        ),
      ) ?? false
    );
  }, [wholeRowData?.rowData]);

  const isCurrentRecordExistINNewRBFilteredBrandLogs = useMemo(() => {
    return (
      sourceData?.isNewRBFilteredBrand_logs?.some((item) =>
        sourceData?.data.dropdown.duplicate_validation_attributes_for_other_flow?.every?.(
          (key) => item?.[key] === wholeRowData?.rowData?.[key],
        ),
      ) ?? false
    );
  }, [wholeRowData?.rowData]);

  const is_Other_Reckit_Brands_Not_Applicable = useMemo(() => {
    if (wholeRowData?.isNewData) return false;
    const DROPDOWN_DATA = sourceData?.data?.dropdown || {};
    const Is_Single_Insert = Object?.keys(rowData || {})?.some((key) => {
      // CHECKS CURRENT COLUMN APPLICABLE FOR OTHER RECKITT BRAND VALIDATION
      const is_single_insert_applicable_column =
        DROPDOWN_DATA?.is_single_insert_applicable_columns?.includes(key);
      // IF NOT VALID RETURN FALSE
      if (!is_single_insert_applicable_column) return false;

      // IF VALID AND THE COLUMN VALUE MATCHES ANY VALUE IN is_single_insert_applicable_values RETURN TRUE
      const result = DROPDOWN_DATA?.is_single_insert_applicable_values?.some(
        (val) => val?.toLowerCase() === (rowData?.[key] || "")?.toLowerCase(),
      );
      return result;
    });

    return Is_Single_Insert;
  }, [rowData]);

  function mergeWithObj2Priority(obj1, obj2) {
    const commonKeys = Object.keys(obj1).filter((key) => key in obj2);

    if (commonKeys.length > 0) {
      // Merge and overwrite obj1 values with obj2 values for common keys
      return {
        ...obj1,
        ...obj2, // obj2 values take priority
      };
    } else {
      // No common keys – just merge all keys
      return {
        ...obj1,
        ...obj2,
      };
    }
  }

  const checkRowDataUpdateStatus = (FinalRowData) => {
    let result = false;

    sourceData.current_mapped_data.forEach((item) => {
      if (item.item_Id === wholeRowData.item_Id) {
        // Condition Check for New Data
        if (wholeRowData.isNewData) {
          // Step 1: Check if all editData fields are null
          const allFieldsNull = Edit_Column_Module.every((editItem) => {
            return rowData[editItem.name] === null;
          });

          if (allFieldsNull) {
            // Step 2: Check Mandatory column values in rowData are non-null
            const allMandotaryFieldsNotNull =
              sourceData.data.dropdown.duplicate_validation_attributes.every(
                (key) => {
                  const options = dropdownOptions[key] || [];
                  if (options.length === 0) return true;
                  return FinalRowData[key] !== null;
                },
              );
            result = allMandotaryFieldsNotNull;
          } else {
            const allMandotaryFieldsNotNull =
              sourceData.data.dropdown.duplicate_validation_attributes.every(
                (key) => {
                  const options = dropdownOptions[key] || [];
                  if (options.length === 0) return true;
                  return FinalRowData[key] !== null;
                },
              );

            // Step 3: Check if any value has updated
            if (!allMandotaryFieldsNotNull) {
              result = false;
            } else {
              const anyFieldChanged = Edit_Column_Module.some((key) => {
                const options = dropdownOptions[key.name] || [];
                if (key.type === "select" && options.length === 0) return true;
                return (
                  FinalRowData[key.name] !== wholeRowData.rowData[key.name]
                );
              });
              result = anyFieldChanged;
            }
          }
        } else {
          // Condition Checks for Existing Data
          // Step 1: Check is any values are changed
          const is_Updated = Object.keys(rowData).some(
            (key) => FinalRowData[key] !== wholeRowData.rowData[key],
          );

          if (is_Updated) {
            result = true;
          } else {
            result = false;
          }
        }
      }
    });

    return result;
  };

  const checkIsNoDuplicateData = () => {
    const DUPLICATE_VALIDATION_ATTRIBUTES =
      sourceData.data.dropdown.duplicate_validation_attributes;
    return allRowsData.every((item) => {
      const Existing_Data = item.rowData;
      //If same rowData no need to check ignore it
      if (item.item_Id === wholeRowData.item_Id) return true;
      // If not the same rowData then check the condition
      const result = DUPLICATE_VALIDATION_ATTRIBUTES.every((attribute) => {
        if (Existing_Data[attribute] === null && rowData[attribute] === null)
          return true;
        return Existing_Data[attribute] === rowData[attribute];
      });

      return !result;
    });
  };

  function normalizeGroup(group) {
    const result = {};

    if (!group) return result;

    // CASE 1: group is an array
    if (Array.isArray(group)) {
      group.forEach(({ key, value }) => {
        result[key] = String(value)
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean)
          .sort();
      });
    }

    // CASE 2: group is an object
    else if (typeof group === "object") {
      Object.entries(group).forEach(([key, value]) => {
        result[key] = String(value)
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean)
          .sort();
      });
    }

    return result;
  }

  function isArrayEdited(arrayOne, arrayTwo) {
    // 🔒 Safety guards
    if (!Array.isArray(arrayOne) && !Array.isArray(arrayTwo)) return false;
    if (!Array.isArray(arrayOne)) return true;
    if (!Array.isArray(arrayTwo)) return false;

    // Extra groups added / removed
    if (arrayTwo.length !== arrayOne.length) return true;

    for (let i = 0; i < arrayOne.length; i++) {
      const group1 = normalizeGroup(arrayOne[i]);
      const group2 = normalizeGroup(arrayTwo[i]);

      const keys1 = Object.keys(group1);
      const keys2 = Object.keys(group2);

      // Extra key added / removed
      if (keys2.length !== keys1.length) return true;

      for (const key of keys1) {
        // Key missing
        if (!group2[key]) return true;

        const values1 = group1[key] || [];
        const values2 = group2[key] || [];

        // Extra value added / removed
        if (values2.length !== values1.length) return true;

        for (const val of values1) {
          if (!values2.includes(val)) return true;
        }
      }
    }

    return false; // ✅ no edits
  }

  const handleSaveRowData = () => {
    setRowHasError(false);
    const DROPDOWN_DATA = sourceData?.data?.dropdown || [];
    const FINAL_FILTERED_RB_BRAND =
      rbBrandValues?.length > 0 ? rbBrandValues : rowData?.FILTERED_RB_BRAND;
    const FinalRowData = {
      ...rowData,
      FILTERED_RB_BRAND: FINAL_FILTERED_RB_BRAND,
    };
    setRowData(FinalRowData);
    setRbBrandValues("");

    // CHECKS CHANGES MADE IN RECORD
    const is_Value_Changed = Edit_Column_Module.some((item) => {
      return FinalRowData?.[item.name] !== wholeRowData.rowData[item.name];
    });

    // LEVELS COLUMN OTHER_LOCAL_ATTRIBUTE VALIDATION
    const IS_VALID_LEVEL_VALUE =
      FinalRowData?.LEVELS && FinalRowData?.LEVELS?.length > 0
        ? FinalRowData?.LEVELS?.every((cond) => {
            const HAS_OTHER_LOCAL_ATTRIBUTE_KEY = cond?.some(
              (item) => item.key === "OTHER_LOCAL_ATTRIBUTE_KEY",
            );
            if (HAS_OTHER_LOCAL_ATTRIBUTE_KEY) {
              const HAS_OTHER_LOCAL_ATTRIBUTE_VALUE = cond?.some(
                (item) => item.key === "OTHER_LOCAL_ATTRIBUTE_VALUE",
              );
              return HAS_OTHER_LOCAL_ATTRIBUTE_VALUE;
            }
            return true;
          })
        : true;

    if (!IS_VALID_LEVEL_VALUE) {
      updateAlert({
        open: true,
        message:
          "Invalid LEVELS column. Please ensure that every OTHER_LOCAL_ATTRIBUTE_KEY has a corresponding OTHER_LOCAL_ATTRIBUTE_VALUE.",
        severity: "error",
        closeFlag: true,
      });
      return;
    }

    if (is_Other_Reckit_Brands_Not_Applicable) {
      updateAlert({
        open: true,
        message: "Cannot add Other Reckitt Brands for this records",
        severity: "error",
        closeFlag: true,
      });
      return;
    }

    const isNewDataUpdate = checkRowDataUpdateStatus(FinalRowData);
    const Is_No_Duplicate_Data = checkIsNoDuplicateData();

    // New dropdown value added check for POWER bRAND
    const IsNewDropdownDataReverted = DROPDOWN_DATA?.["POWER_BRAND"]?.some(
      (item) => item === FinalRowData?.["POWER_BRAND"] || "",
    );

    const IsNewDropdownDataRevertedTwo = FinalRowData?.["FILTERED_RB_BRAND"]
      ?.split(/\s*,\s*/)
      .every?.((item) => {
        return DROPDOWN_DATA?.["FILTERED_RB_BRAND"]?.includes(item);
      });

    const IsColumnValueValid = Edit_Column_Module?.every((item) => {
      const value = FinalRowData?.[item.name];

      // Skip validation if reverted
      if (!IsNewDropdownDataReverted) return true;
      if (!IsNewDropdownDataRevertedTwo) return true;
      // Skip empty/null values
      if (!value || value === "null") return true;
      if (item.name === "LEVELS") return true;

      const dropdownValues = DROPDOWN_DATA?.[item.name] || [];
      const isProperValue = dropdownValues.some((val) => val === value);
      return isProperValue;
    });

    if (!IsColumnValueValid) {
      updateAlert({
        open: true,
        message: "Column values are invalid",
        severity: "error",
        closeFlag: true,
      });
      return;
    }

    const IsNewDropdownData = !IsNewDropdownDataReverted
      ? wholeRowData?.isPowerBrandNew
        ? wholeRowData?.isPowerBrandNew
        : sourceData.isNewPowerBrandDropdownValue
      : sourceData.isNewPowerBrandDropdownValue;

    const IsNewDropdownDataTwo = !IsNewDropdownDataRevertedTwo
      ? wholeRowData?.isRBFilteredBrandNew
        ? wholeRowData?.isRBFilteredBrandNew
        : sourceData.isNewRBFilteredBrandDropdownValue
      : sourceData.isNewRBFilteredBrandDropdownValue;

    if (
      IsNewDropdownData ||
      IsNewDropdownDataTwo ||
      isCurrentRecordExistINNewPowerBrandLogs ||
      isCurrentRecordExistINNewRBFilteredBrandLogs
    ) {
      let UpdatedIsNewMappingTypeLogs = [];
      let UpdatedIsNewMappingTypeLogsForRBFilteredBrand = [];
      if (isCurrentRecordExistINNewPowerBrandLogs) {
        if (IsNewDropdownDataReverted) {
          UpdatedIsNewMappingTypeLogs =
            sourceData?.isNewPowerBrand_logs?.filter((item) => {
              const isSameData =
                sourceData?.data?.dropdown?.duplicate_validation_attributes_for_other_flow?.every?.(
                  (key) => item?.[key] === wholeRowData?.rowData?.[key],
                ) ?? false;
              return !isSameData;
            });
        } else {
          UpdatedIsNewMappingTypeLogs = sourceData?.isNewPowerBrand_logs?.map(
            (item) => {
              const isSameData =
                sourceData?.data?.dropdown?.duplicate_validation_attributes_for_other_flow?.every?.(
                  (key) => item?.[key] === wholeRowData?.rowData?.[key],
                ) ?? false;
              return isSameData ? FinalRowData : item;
            },
          );
        }
      }

      if (isCurrentRecordExistINNewRBFilteredBrandLogs) {
        if (IsNewDropdownDataReverted) {
          UpdatedIsNewMappingTypeLogsForRBFilteredBrand =
            sourceData?.isNewRBFilteredBrand_logs?.filter((item) => {
              const isSameData =
                sourceData?.data?.dropdown?.duplicate_validation_attributes_for_other_flow?.every?.(
                  (key) => item?.[key] === wholeRowData?.rowData?.[key],
                ) ?? false;
              return !isSameData;
            });
        } else {
          UpdatedIsNewMappingTypeLogsForRBFilteredBrand =
            sourceData?.isNewRBFilteredBrand_logs?.map((item) => {
              const isSameData =
                sourceData?.data?.dropdown?.duplicate_validation_attributes_for_other_flow?.every?.(
                  (key) => item?.[key] === wholeRowData?.rowData?.[key],
                ) ?? false;
              return isSameData ? FinalRowData : item;
            });
        }
      }

      if (IsNewDropdownData && !isCurrentRecordExistINNewPowerBrandLogs) {
        UpdatedIsNewMappingTypeLogs = [
          ...sourceData.isNewPowerBrand_logs,
          FinalRowData,
        ];
        updateSourceInputs("isNewPowerBrand_logs", UpdatedIsNewMappingTypeLogs);
      }

      if (
        IsNewDropdownDataTwo &&
        !isCurrentRecordExistINNewRBFilteredBrandLogs
      ) {
        UpdatedIsNewMappingTypeLogsForRBFilteredBrand = [
          ...sourceData.isNewRBFilteredBrand_logs,
          FinalRowData,
        ];
        updateSourceInputs(
          "isNewRBFilteredBrand_logs",
          UpdatedIsNewMappingTypeLogsForRBFilteredBrand,
        );
      }
    }

    updateSourceInputs("isNewPowerBrandDropdownValue", false);
    updateSourceInputs("isNewRBFilteredBrandDropdownValue", false);

    if (isNewDataUpdate && Is_No_Duplicate_Data && IsColumnValueValid) {
      let updatedArray;
      if (wholeRowData.isNewData) {
        const MODIFIED_MAPPED_DATA = sourceData.modified_mapped_data;

        const isAlreadyEdited = MODIFIED_MAPPED_DATA.some((item) => {
          const updated = item.updated;
          return sourceData?.data?.dropdown?.duplicate_validation_attributes_for_other_flow?.every(
            (key) => {
              if (key === "LEVELS") {
                const edited = isArrayEdited(updated[key], FinalRowData[key]);
                return edited;
              }
              return updated[key] === FinalRowData[key];
            },
          );
        });

        if (isAlreadyEdited) {
          const Updated_Modified_data = MODIFIED_MAPPED_DATA.map((item) => {
            const updated = item.updated;
            const isEditedRowData =
              sourceData?.data?.dropdown?.duplicate_validation_attributes_for_other_flow?.every(
                (key) => {
                  if (key === "LEVELS") {
                    const edited = isArrayEdited(
                      updated[key],
                      FinalRowData[key],
                    );
                    return edited;
                  }
                  return updated[key] === FinalRowData[key];
                },
              );

            if (isEditedRowData) {
              return {
                ...item,
                updated: { ...FinalRowData },
              };
            } else {
              return item;
            }
          });

          updatedArray = Updated_Modified_data;
        } else {
          const Updated_Modified_Data = [
            {
              actual: {},
              updated: { ...FinalRowData },
              isNew: true,
              isDeleted: false,
              isEdited: false,
            },
            ...MODIFIED_MAPPED_DATA,
          ];
          updatedArray = Updated_Modified_Data;
        }
      } else {
        const MODIFIED_MAPPED_DATA = sourceData?.modified_mapped_data || [];
        const isAlreadyEdited = MODIFIED_MAPPED_DATA.some((item) => {
          const updated = mergeWithObj2Priority(FinalRowData, item.updated);
          return Object.keys(FinalRowData).every((key) => {
            if (key === "LEVELS") {
              const edited = isArrayEdited(updated[key], FinalRowData[key]);
              return edited;
            }
            return updated[key] === FinalRowData[key];
          });
        });

        if (isAlreadyEdited) {
          const Updated_Modified_data = MODIFIED_MAPPED_DATA.map((item) => {
            const updated = mergeWithObj2Priority(FinalRowData, item.updated);
            const isEditedRowData =
              sourceData?.data?.dropdown?.duplicate_validation_attributes_for_other_flow?.every(
                (key) => {
                  if (key === "LEVELS") {
                    const edited = isArrayEdited(
                      updated[key],
                      FinalRowData[key],
                    );
                    return edited;
                  }
                  return updated[key] === FinalRowData[key];
                },
              );

            if (isEditedRowData) {
              return {
                ...item,
                updated: { ...item.updated, ...updatedData },
              };
            } else {
              return item;
            }
          });

          updatedArray = Updated_Modified_data;
        } else {
          const COMBINED_UPDATED_DATA = mergeWithObj2Priority(
            FinalRowData,
            updatedData,
          );
          const Updated_Modified_Data = [
            ...MODIFIED_MAPPED_DATA,
            {
              actual: {
                ...FinalRowData,
                COUNTRY_CODE: sourceData.current_country_code,
              },
              updated: {
                ...COMBINED_UPDATED_DATA,
                COUNTRY_CODE: sourceData.current_country_code,
              },
              isNew: false,
              isDeleted: false,
              isEdited: true,
            },
          ];
          updatedArray = Updated_Modified_Data;
        }
      }

      //Updating the redux store with final result
      updateSourceInputs("modified_mapped_data", updatedArray);
      handleSave(
        FinalRowData,
        wholeRowData.item_Id,
        IsNewDropdownData,
        IsNewDropdownDataTwo,
      );
      setIsEditDialogOpen(false);
    } else {
      setRowHasError(true);
      if (Is_No_Duplicate_Data) {
        !is_Value_Changed
          ? updateAlert({
              open: true,
              message: "No Value has been changed",
              severity: "error",
              closeFlag: true,
            })
          : !isNewDataUpdate
            ? updateAlert({
                open: true,
                message: "Mandotory columns cannot be Empty",
                severity: "error",
                closeFlag: true,
              })
            : updateAlert({
                open: true,
                message: "Values cannot be Empty",
                severity: "error",
                closeFlag: true,
              });
      } else {
        updateAlert({
          open: true,
          message: "Cannot add duplicate entries",
          severity: "error",
          closeFlag: true,
        });
      }
    }
  };

  const handleClose = () => {
    if (wholeRowData.isNewData && !Is_New_Data_Not_Null) {
      handleDeleteRow(wholeRowData);
      setIsEditDialogOpen(false);
    } else {
      setRowData(wholeRowData?.rowData || {});
      setIsEditDialogOpen(false);
    }
  };

  const containedButton = {
    color: "white",
    backgroundColor: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const outlinedCNCButton = {
    borderColor: "#46596A",
    color: "#46596A",
    // width: '100%',
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  useEffect(() => {
    setRowData(wholeRowData?.rowData || {});
  }, [wholeRowData]);

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={openModel}
        onClose={handleClose}
      >
        <DialogTitle>
          {wholeRowData.isNewData ? "Insert new" : "Edit"}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            <EditableRowPPB
              key={wholeRowData.item_Id}
              updateAlert={updateAlert}
              tableName={tableName}
              customStyles={{}}
              wholeRowData={wholeRowData}
              rowData={rowData}
              setRowData={setRowData}
              dropdownOptions={dropdownOptions}
              setDropdownOptions={setDropdownOptions}
              setUpdatedRowData={setUpdatedRowData}
              rowHasError={rowHasError}
              setRowHasError={setRowHasError}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              editingIndex={editingIndex}
              handleDeleteRow={handleDeleteRow}
              allRowsData={allRowsData}
              editData={wholeRowData?.rowData || {}}
              updateSourceInputs={updateSourceInputs}
              sourceData={sourceData}
              selectClasses={selectClasses}
              inputClasses={inputClasses}
              rbBrandValues={rbBrandValues}
              setRbBrandValues={setRbBrandValues}
            />
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ marginBottom: "5px" }}>
          <Button
            disableFocusRipple
            variant="outlined"
            style={outlinedCNCButton}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            disableFocusRipple
            style={containedButton}
            onClick={handleSaveRowData}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
